import { Icon, Text, VStack } from "@chakra-ui/react";
import TickIcon from "../../../assets/svg/cross.svg?react";
import CustomButton from "../../../components/common/Button";

interface IRejectedProps {
  onOpen: VoidFunction;
  setShowOnBoarding: React.Dispatch<React.SetStateAction<boolean>>;
  setModalShownInSession: React.Dispatch<React.SetStateAction<boolean>>;
}
const Rejected: React.FC<IRejectedProps> = ({
  onOpen,
  setModalShownInSession,
  setShowOnBoarding,
}) => {
  const handleButtonClick = () => {
    setShowOnBoarding(true);
    setModalShownInSession(false);
    onOpen();
  };
  return (
    <>
      <VStack gap={6} width={"50%"}>
        <Icon as={TickIcon} boxSize={"56px"} />
        <VStack gap={2}>
          <Text
            fontSize={"xl"}
            fontWeight={"bold"}
            color={"text.primary"}
            textAlign={"center"}
          >
            Document Verification Unsuccessful
          </Text>
          <Text textAlign={"center"} fontSize={"md"} color={"text.secondary"}>
            Thank you for submitting your document. Unfortunately, we were
            unable to verify it successfully. Please review the details and
            resubmit with the correct information. If you need assistance, feel
            free to reach out to our support team or check your account for more
            details.
          </Text>{" "}
          cs
        </VStack>
        <CustomButton
          fontSize="md"
          fontWeight="semibold"
          type="submit"
          fontFamily={"primary"}
          px={12}
          onClick={handleButtonClick}
        >
          Update and Resubmit
        </CustomButton>
      </VStack>
    </>
  );
};
export default Rejected;
